import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { Flex, Box, Heading, Text, Image, Button, Link as ExternalLink } from '@theme-ui/components'
import axios from 'axios-jsonp'
import jsonpAdapter from 'axios-jsonp'

const Shout = () => {
  const [shoutData, setShoutData] = useState(null)

  useEffect(() => {
    axios({
      url: `https://data.prod.gonation.com/profile/shoutsnew/bzn-T3kF_7UOQh6cN9IMHT068Q`,
      adapter: jsonpAdapter
    }).then(res => {
      setShoutData(res.data)
    })
  }, [])

  const addHTTP = url => {
    var prefix = 'https://'
    if (url.substr(0, prefix.length) !== prefix) {
      return prefix + url
    }
    return url
  }

  const renderCTAs = () => {
    const buttonNames = Object?.keys(shoutData?.shout?.ctas)
    const { ctas } = shoutData?.shout
    return buttonNames
      .filter(btn => btn !== 'cta1' && btn !== 'cta2')
      .map(button => {
        if (ctas[button].includes('.com')) {
          return (
            <ExternalLink target="_blank" rel="noopener noreferrer" href={addHTTP(ctas[button])} sx={styles.cta}>
              {button}
            </ExternalLink>
          )
        }
        return (
          <Link to={ctas[button]}>
            <Button sx={styles.cta}>{button}</Button>
          </Link>
        )
      })
  }

  if (shoutData !== null) {
    const {
      shout: { text, image }
    } = shoutData
    const { isDefault } = image
    return (
      <Box sx={styles.container}>
        <Flex sx={styles.innerContainer}>
          {isDefault ? (
            ''
          ) : (
            <Box sx={styles.imageContainer}>
              <Image
                alt="Recent Announcement from Tonys At The J House"
                src={`${shoutData.imageBaseUrl}/${image.image.cloudinaryId}`}
              ></Image>
            </Box>
          )}

          <Box sx={styles.content}>
            <Heading sx={styles.title}>Recent Shout</Heading>
            <Box sx={styles.line}></Box>
            <Text as="p" sx={styles.text}>
              {text}
            </Text>
            <Box sx={styles.ctaContainer}>{shoutData?.shout?.ctas && renderCTAs()}</Box>
          </Box>
        </Flex>
      </Box>
    )
  }
  return ''
}

export default Shout

const styles = {
  container: {
    padding: 2,
    pt: 12,
    padding: ['3rem 1rem', '', '6rem 2rem 6rem 6rem'],
    '.title': {
      fontSize: ['2rem', '2.5rem', '3rem']
    }
  },
  innerContainer: {
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '::after': {
      content: "''",
      width: '80%',
      height: '110%',
      position: 'absolute',
      left: '-4rem',
      zIndex: '-1'
    }
  },
  imageContainer: {
    width: ['100%', '100%', '50%'],
    img: {
      width: '100%',
      maxHeight: '60vh',
      boxShadow: '3px 3px 10px black',
      border: 'solid 4px',
      borderColor: 'secondary',
      objectFit: 'cover'
    }
  },

  content: {
    width: ['100%', '100%', '50%'],
    padding: '3rem',
    position: 'relative',
    left: ['', '', '-5rem'],
    backgroundColor: '#0c2240',
    height: 'auto',
    // boxShadow: '3px 3px 10px black',
    color: 'white',
    border: 'solid 4px',
    borderColor: 'secondary'
  },
  title: {
    fontSize: [5, 5, 6],
    fontWeight: 200,
    mb: 3
  },

  text: {
    color: 'white',
    fontFamily: 'heading',
    fontWeight: 400,
    fontSize: [2, 2, 3],
    maxWidth: '650px'
  },
  line: {
    width: '75px',
    height: '2px',
    backgroundColor: 'secondary',
    mb: [6, 7, 8]
  },
  ctaContainer: {
    mt: [4, 5, 9]
  },
  cta: {
    padding: ['1rem 4rem', '1rem 4rem', '1rem 4rem'],
    fontSize: [1, 1, 2],
    cursor: 'pointer'
  }
}
